import React, { useState } from "react";
import { Form, Input, InputNumber, Popconfirm, Table, Typography } from "antd";
import Style from './DeliverCostTabel.module.scss'
import { errorToast } from "../../../../Utils/Toast/Toast";

const originData = [];
for (let i = 0; i < 100; i++) {
  originData.push({
    key: i.toString(),
    name: `Edrward ${i}`,
    age: 32,
    address: `London Park no. ${i}`,
  });
}
const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === "number" ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `وارد نشده!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
const DeliverCostTabel = ({ costData,UpdateData ,loadingPage}) => {
  const [form] = Form.useForm();
  const [data, setData] = useState();
  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      name: "",
      age: "",
      address: "",
      ...record,
    });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey("");
  };

  function diff(obj1, obj2) {
    const result = {};
    if (Object.is(obj1, obj2)) {
        return undefined;
    }
    if (!obj2 || typeof obj2 !== 'object') {
        return obj2;
    }
    Object.keys(obj1 || {}).concat(Object.keys(obj2 || {})).forEach(key => {
        if(obj2[key] !== obj1[key] && !Object.is(obj1[key], obj2[key])) {
            result[key] = obj2[key];
        }
        if(typeof obj2[key] === 'object' && typeof obj1[key] === 'object') {
            const value = diff(obj1[key], obj2[key]);
            if (value !== undefined) {
                result[key] = value;
            }
        }
    });
    return result;
}
  const save = async (key,record) => {

    const newData = [...dataSource];
    const index = newData.findIndex((item) => key === item.key);
    const row = await form.validateFields();
    const item = newData[index];
    newData.splice(index, 1, {
          ...item,
          ...row,
        });    
    UpdateData(index,diff(dataSource[index],newData[index]))
        setEditingKey('')
    // const item = newData[index];
    //     newData.splice(index, 1, {
    //       ...item,
    //       ...row,
    //     });
    // let intersection = dataSource[index].filter(x => !record.includes(x));
    // try {
    //   const row = await form.validateFields();
      
    //   const newData = [...dataSource];
    //   const index = newData.findIndex((item) => key === item.key);
    //   if (index > -1) {
    //     const item = newData[index];
    //     newData.splice(index, 1, {
    //       ...item,
    //       ...row,
    //     });
    //     let intersection = newData.filter(x => !dataSource.includes(x));
    //     setData(intersection);
    //     setEditingKey("");
    //   } else {
    //     newData.push(row);
    //     setData(newData);
    //     setEditingKey("");
    //   }
    // } 
    // catch (errInfo) {
    //   console.log("ورودی اشتباه :", errInfo);
    // }
  };
  

  let month = costData && Object.keys(costData);

  let monthColumn = [];
  month&&month.forEach((element) => {
    monthColumn.push({
      title: element,
      dataIndex: element,
      editable: true,
    });
  });
  const columns = [
    {
      title: "عملیات",
      dataIndex: "operation",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.key,record)}
              style={{
                marginLeft: 8,
              }}
            >
              تغییر
            </Typography.Link>
            <Popconfirm title="مطمئنید?" onConfirm={cancel}>
              <a>بیخیال</a>
            </Popconfirm>
          </span>
        ) : (
          <Typography.Link
            disabled={editingKey !== ""}
            onClick={() => edit(record)}
          >
            ویرایش
          </Typography.Link>
        );
      },
    },
  ];

let saatArray=[{
    title: 'ساعت',
    dataIndex: 'Hour',
    editable: false,
  }]
  let monthWithHour=saatArray.concat(monthColumn)
  let columnsList=monthWithHour.concat(columns)
  let dailyHour=["00:00","01:00","02:00","03:00","04:00","05:00","06:00","07:00","08:00","09:00","10:00","11:00","12:00","13:00","14:00","15:00","16:00","17:00","18:00","19:00","20:00","21:00","22:00","23:00"]
  let dataSource = [];
  let index = 0;
  costData&&[costData].forEach(element => {
      Object.values(element)[0][0].forEach(e=>{
        dataSource.push({
            key:index,
            Hour:dailyHour[index],
            Apr:Object.values(element)[0][0][index],
            Aug:Object.values(element)[1][0][index],
            Dec:Object.values(element)[2][0][index],
            Feb:Object.values(element)[3][0][index],
            Jan:Object.values(element)[4][0][index],
            Jul:Object.values(element)[5][0][index],
            Jun:Object.values(element)[6][0][index],
            Mar:Object.values(element)[7][0][index],
            May:Object.values(element)[8][0][index],
            Nov:Object.values(element)[9][0][index],
            Oct:Object.values(element)[10][0][index],
            Sep:Object.values(element)[11][0][index],
        })
        index=index+1
    })
  });

  const mergedColumns = columnsList.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "age" ? "number" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
      <div className={Style.TabelHolder}>
    <Form form={form} component={false}>
      <Table
        components={{
          body: {
            cell: EditableCell,
          },
        }}
        bordered
        dataSource={dataSource}
        scroll={{x:1500, y: 400 }}
        columns={mergedColumns}
        rowClassName="editable-row"
        pagination={{ pageSize: 24 }}
        loading={loadingPage||costData===null}
      />
    </Form>
      </div>

  );
};
export default DeliverCostTabel;
